<style scoped lang="scss">
    @import "../../styles/hos";
    .status {
        background: #E6F1FC;
        height: 40px;
    }
</style>
<template>
    <div class="container bg_fff">
        <breadcrumb :pages="['转诊详情']"></breadcrumb>
        <!--<div class="status pl15 flex aic fs18 color_main">-->
            <!--状态：{{$route.query.referralStatusDescription}}-->
        <!--</div>-->
        <hos_state_apply_detail :state="$route.query.referralStatus"></hos_state_apply_detail>
        <div class="pt15 pl15 pr15 pb15 flex">
            <div class="flex1 pr15">
                <!--<referral-base-form ref="baseForm" :readonly="true" :value="info"></referral-base-form>-->
                <base_form_detail :detail="info"></base_form_detail>
                <referral_condition_form_detail :detail="info" ref="condition" :from="from"></referral_condition_form_detail>
                <!--<referral-condition-form ref="conditionForm" :readonly="true" :value="info"-->
                                         <!--:aspectUser="aspectUser"></referral-condition-form>-->
            </div>
            <div class="flex1 blshow pl15">
                <!--<referral-apply-form ref="applyForm" :readonly="true" :value="info"></referral-apply-form>-->
                <apply_form_detail :detail="info"></apply_form_detail>

                <referral-check-form ref="checkForm"
                                     v-if="showCheckForm"
                                     @currActionChange="currActionChange"></referral-check-form>
                <referral-missing-form :list="consultPerfectDetailList" v-if="showMissingForm"></referral-missing-form>
                <referral-arrange-form v-if="referralStatus==='FINSH'" :value="info"
                                       :readonly="true"></referral-arrange-form>
                <referral-disagree-form :value="info"
                                        v-if="referralStatus==='CANCEL'||referralStatus==='REFUSED'"
                                        :referral-status="referralStatus"></referral-disagree-form>
                <div class="flex jcc mt15">
                    <!--<el-button size="mini" @click="$router.back()">返回</el-button>-->
                    <!--<el-button size="mini" :type="btn.type" @click="doReferralAction(btn.name,info)"-->
                               <!--v-for="(btn,index) in btns"-->
                               <!--:key="index">-->
                        <!--{{btn.name}}-->
                    <!--</el-button>-->
                    <hos_button :content="btn.name" @clickEvent="doReferralAction(btn.name,info)" v-for="(btn,index) in btns"
                                :key="index" class="mr50"/>
                </div>
            </div>
        </div>



        <!--<div class="pl15 pr15 pb15">-->
            <!--<div class="status pl15 flex aic fs18 color_main">-->
                <!--状态：{{$route.query.referralStatusDescription}}-->
            <!--</div>-->
            <!--<referral-base-form ref="baseForm" :readonly="true" :value="info"></referral-base-form>-->
            <!--<referral-condition-form ref="conditionForm" :readonly="true" :value="info"-->
                                     <!--:aspectUser="aspectUser"></referral-condition-form>-->
            <!--<referral-apply-form ref="applyForm" :readonly="true" :value="info"></referral-apply-form>-->
            <!--<referral-check-form ref="checkForm"-->
                                 <!--v-if="showCheckForm"-->
                                 <!--@currActionChange="currActionChange"></referral-check-form>-->
            <!--<referral-missing-form :list="consultPerfectDetailList" v-if="showMissingForm"></referral-missing-form>-->
            <!--<referral-arrange-form v-if="referralStatus==='FINSH'" :value="info"-->
                                   <!--:readonly="true"></referral-arrange-form>-->
            <!--<referral-disagree-form :value="info"-->
                                    <!--v-if="referralStatus==='CANCEL'||referralStatus==='REFUSED'"-->
                                    <!--:referral-status="referralStatus"></referral-disagree-form>-->
            <!--<div class="flex jcc mt15">-->
                <!--<el-button size="mini" @click="$router.back()">返回</el-button>-->
                <!--<el-button size="mini" :type="btn.type" @click="doReferralAction(btn.name,info)"-->
                           <!--v-for="(btn,index) in btns"-->
                           <!--:key="index">-->
                    <!--{{btn.name}}-->
                <!--</el-button>-->
            <!--</div>-->
        <!--</div>-->
        <Referral-addNum-dialog ref="addNumDialog" @addNum="doReferralAction('门诊安排')"></Referral-addNum-dialog>
        <referral-scheme-dialog ref="schemeDialog" @scheme-change="schemeChange"></referral-scheme-dialog>
        <referral-num-dialog ref="numDialog" @next="next"></referral-num-dialog>
        <referral-confirm-dialog ref="confirmDialog" @submit="submit"></referral-confirm-dialog>
        <referral-bed-num-dialog ref="bedNumDialog" @next="next"></referral-bed-num-dialog>
        <referral-bed-confirm-dialog ref="bedConfirmDialog" @submit="submit"></referral-bed-confirm-dialog>

        <referral-end-dialog ref="endDialog"></referral-end-dialog>
        <hos_dialog_detail ref="detail_dialog"
                            @cancle="cancleEvent"
        ></hos_dialog_detail>
    </div>
</template>

<script>
  import {referralMixin} from "../../lib/mixins/referral";
  import Breadcrumb from "../../components/common/Breadcrumb";
  import ReferralBaseForm from "../../components/referral/base-form";
  import ReferralConditionForm from "../../components/referral/condition-form";
  import ReferralApplyForm from "../../components/referral/apply-form";
  import {referralService} from "../../lib/service/referral";
  import {commonGetBtns} from "../../lib/utils";
  import {REFERRAL_BTN} from "../../lib/config";
  import ReferralCheckForm from "../../components/referral/check-form";
  import ReferralArrangeForm from "../../components/referral/arrange-form";
  import ReferralMissingForm from "../../components/referral/missing-form";
  import ReferralSchemeDialog from "../../components/referral/scheme-dialog";
  import ReferralNumDialog from "../../components/referral/num-dialog";
  import ReferralConfirmDialog from "../../components/referral/confirm-dialog";
  import ReferralDisagreeForm from "../../components/referral/disagree-form";
  import ReferralBedConfirmDialog from "../../components/referral/bed-confirm-dialog";
  import ReferralBedNumDialog from "../../components/referral/bed-num-dialog";
  import ReferralAddNumDialog from "../../components/referral/addNum-dialog"
  import ReferralEndDialog from "../../components/referral/addNum-end-dialog"

  import base_form_detail from "../../components/referral/base-form_detail"
  import referral_condition_form_detail from "../../components/referral/referral-condition-form-detail"
  import apply_form_detail from "../../components/referral/apply-form-detail"
  import hos_button from "../../components/hos/hos-button"
  import hos_state_apply_detail from "../../components/hos/hos-state-apply-detail"
  import hos_dialog_detail from "../../components/hos/hos-dialog-detail"

  export default {
    name: "ReferralDetail",
    data() {
      return {
        id: '',
        action: '资料就绪',
        info: {},
        isChecked: false,
        arrangeOrder: {},
          from:""
      }
    },
    computed: {
      aspectUser() {
        let aspectUser = '';
        const {info, docInfo} = this;
        const {type} = this.$route.query;
        if (type) aspectUser = type;
        else {
          if (docInfo.hosId === info.initHosId) aspectUser = 'init';
          else aspectUser = 'accept';
        }
        return aspectUser;
      },
      referralStatus() {
        return this.info.referralStatus || '';
      },
      auditStatus() {
        return this.info.auditStatus || false;
      },
      consultPerfectDetailList() {
        let list = this.info.consultPerfectDetailList || [];
        list.splice(1);
        return list;
      },
      showMissingForm() {
        const {auditStatus, aspectUser, referralStatus} = this;
        if (referralStatus === 'WAIT_EXAMINE') {
          if (auditStatus === false) return true;
        }
        return false;
      },
      showCheckForm() {
        const {auditStatus, aspectUser, referralStatus} = this;
        if (aspectUser === 'accept' && referralStatus === 'WAIT_EXAMINE' && auditStatus) {
          return true;
        }
        return false;
      },
      btns() {
        let btns = [];
        const {auditStatus, referralType} = this.info;
        const {action, consultPerfectDetailList, aspectUser, isChecked} = this;
        switch (this.referralStatus) {
            case 'FINSH':
                if (aspectUser === 'init') {
                    btns = ['确定上传'];
                }
                break;
          case 'REFUSED':
            if (aspectUser === 'init') {
              btns = ['再次申请'];
            }
            break;
          case 'CANCEL':
            if (aspectUser === 'init') {
              btns = ['再次申请'];
            }
            break;
          case 'WAIT_EXAMINE':
            if (aspectUser === 'init') {
              btns = ['取消申请','确定上传'];
              if (auditStatus === false) {
                btns.push('确认补充');
              }
            } else if (aspectUser === 'accept') {
              if (auditStatus === false) {

              } else if (action === '资料就绪' && referralType === '门诊转诊') {
                if (isChecked) {
                  btns = ['提交'];
                } else {
                  btns = ['审核通过', '提交'];
                }

              } else if (action === '资料就绪' && referralType === '住院转诊') {
                if (isChecked) {
                  btns = [ '提交'];
                } else {
                  btns = ['审核通过', '提交'];
                }
              } else btns = ['提交'];
            }
        }
        return commonGetBtns(btns, REFERRAL_BTN);
      }
    },
    components: {
      ReferralBedNumDialog,
      ReferralBedConfirmDialog,
      ReferralDisagreeForm,
      ReferralConfirmDialog,
      ReferralNumDialog,
      ReferralSchemeDialog,
      ReferralMissingForm,
      ReferralArrangeForm,
      ReferralCheckForm, ReferralApplyForm, ReferralConditionForm, Breadcrumb,ReferralAddNumDialog,
        base_form_detail,referral_condition_form_detail,apply_form_detail,hos_button,ReferralEndDialog,
        hos_state_apply_detail,hos_dialog_detail
    },
    mixins: [referralMixin],
    created() {
      this.id = this.$route.params.id;
      this.from = this.$route.query.type;
      this.getDetail();
    },
    methods: {
      currActionChange(data) {
        this.action = data;
      },
      schemeChange(name, data) {
        this.doReferralAction(name, {
          ...data
        });
      },
      next(name, data) {
        this.doReferralAction(name, {
          ...data,
          order: this.info,
          docId: data.scheme.docId
        })
      },
      submit(name, data) {
        this.doReferralAction(name, data);
      },
      async getDetail() {
        this.info = await referralService.detail(this.id);
      },
        async cancleEvent(reson){
            if (await referralService.cancel({
                id: this.id,
                refuseReason: reson
            })) {
                this.$message.success('成功取消申请');
                bus.$emit('top0', 0);
                if (this.getDetail) this.getDetail();
            }
        }
    }
  }
</script>
